import { useEffect, useState } from 'react';
import { ONBOARDING_NOT_LOADED, subscribeOnboarding, type OnboardingState } from '@/lib/onboarding';

/** Live `private/settings.onboarding` of the signed-in user (#96). */
export function useOnboarding(uid: string | null | undefined): OnboardingState {
  const [state, setState] = useState<OnboardingState>(ONBOARDING_NOT_LOADED);
  useEffect(() => {
    setState(ONBOARDING_NOT_LOADED);
    if (!uid) return;
    return subscribeOnboarding(uid, setState);
  }, [uid]);
  return state;
}
